import PropTypes from 'prop-types'
import { createContext, useContext } from 'react'

import { readParam, useCopy } from '../../i18n'
import { BRANCHES } from './copy'

/**
 * Branchen-Personalisierung wie im Demo-Deck (nur für Präsentierende).
 * Die Auswahl steht in ?branche= und überlebt den Sprachwechsel.
 */

export const readBranch = () => {
  const id = readParam('branche')
  return BRANCHES.find((b) => b.id === id) ? id : 'allgemein'
}

const BranchContext = createContext('allgemein')

export const BranchProvider = BranchContext.Provider

export const useBranch = () => {
  const id = useContext(BranchContext)
  return BRANCHES.find((b) => b.id === id) || BRANCHES[0]
}

// Die Nav sitzt im Story-Provider, deshalb liest der Picker die Copy selbst
export function BranchPicker({ value, onChange }) {
  const c = useCopy('branches')
  return (
    <label className='dms-branch'>
      <span className='sr-only'>{c.label}</span>
      <select
        className='sc-select'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        title={c.label}
      >
        {BRANCHES.map((b) => (
          <option key={b.id} value={b.id}>
            {b.id === 'allgemein'
              ? `${c.label}: ${c.names[b.id]}`
              : c.names[b.id]}
          </option>
        ))}
      </select>
    </label>
  )
}

BranchPicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}
